import styled, { keyframes } from "styled-components";

const moveText = keyframes`
  0% {
    transform: translateX(500%); 
  }
  100% {
    transform: translateX(-500%);
  }
`;

export const BarContainer = styled.section`
  display: flex;
  justify-content: center;
`;

export const BarText = styled.p`
  font-family: kreuz;
  text-transform: uppercase;
  font-size: 1.5vw;
  margin: 0;
  animation: ${moveText} 15s linear infinite;
`;